import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Secure.module.scss';

export const SecureMainSection = () => (
  <WorkPageLayout
    isMain
    leftContent={
      <div className={styles.secureLeftSection}>
        <span className={styles.secureMain_1}>Secure Data with</span>
        <span className={styles.secureMain_2}>FCE</span>
        <span className={styles.secureMain_3}>Blockchain</span>
        <span className={styles.secureMain_4}>and</span>
        <span className={styles.secureMain_5}>Tokenization</span>
      </div>
    }
    rightContent={null}
  />
);
